import SearchInput, { TSearchInputRef, IProps } from './SearchInput';

export type { TSearchInputRef, IProps };
export default SearchInput;
